import { render } from "./ProjectMemberEditor.vue?vue&type=template&id=2afba206&scoped=true"
import script from "./ProjectMemberEditor.vue?vue&type=script&lang=js"
export * from "./ProjectMemberEditor.vue?vue&type=script&lang=js"

import "./ProjectMemberEditor.vue?vue&type=style&index=0&id=2afba206&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afba206"]])

export default __exports__